<template>
  <div class="m-grid m-grid--hor m-grid--root m-page">

    <AppHeader/>

    <!-- begin::Body -->
    <div class="m-grid__item m-grid__item--fluid m-grid m-grid--ver-desktop m-grid--desktop m-body">

      <LeftMenu/>

      <div class="m-grid__item m-grid__item--fluid m-wrapper" v-if="canSeeAnalyticsDirectorySection">

        <div class="m-content">

          <div class="row">
            <div class="col-xl-12">
              <div class="m-portlet m-portlet--rounded m-portlet--head-sm fullable-portlet"
                   :m-portlet="'true'">
                <div class="m-portlet__head">
                  <div class="m-portlet__head-caption">
                    <div class="m-portlet__head-title">
                      <span class="m-portlet__head-icon">
                          <i class="flaticon-diagram m--font-brand m--icon-font-size-lg2 mt-n1"></i>
                      </span>
                      <h3 class="m-portlet__head-text">
                        {{$t('menus.main.analytics')}}{{$t('Directory.headingSuffix')}}
                      </h3>
                    </div>
                  </div>
                  <div class="m-portlet__head-tools">
                    <ul class="m-portlet__nav">

                      <li class="m-portlet__nav-item">
                        <a href="javascript:"
                           :m-portlet-tool="'fullscreen'" data-trigger="hover"
                           class="m-portlet__nav-link m-portlet__nav-link--icon"><i class="la la-expand"></i></a>
                      </li>
                    </ul>
                  </div>
                </div>

                <div class="m-portlet__body m-form">
                  <div class="" id="search">
                    <div id="metrics">
                      <form class="m-form--label-align-left- m-form--state-"
                            id="filterForm"
                            @submit.prevent="startSearch()">
                        <div class="row" id="DateFilter">

                          <div class="col-6">
                            <div class="form-group">
                              <div class="m-form_label">
                                <label for="From" class="control-label">{{$t('Property.Analytics.From')}}:</label>
                              </div>
                              <input type="date"
                                     min="2016-04-01"
                                     v-model="filter.FromDate"
                                     class="form-control m-input  m-input--solid"
                                     id="From"
                                     name="From"/>
                            </div>
                          </div>
                          <div class="col-6">
                            <div class="form-group">
                              <div class="m-form_label">
                                <label for="To" class="control-label">{{$t('Property.Analytics.To')}}:</label>
                              </div>
                              <input type="date"
                                     v-model="filter.ToDate"
                                     class="form-control m-input  m-input--solid"
                                     id="To"
                                     name="To"/>
                            </div>
                          </div>
                          <div class="col-12">
                            <button type="submit" class="btn btn-brand btn-sm m-btn m-btn--custom m-btn--icon btn-block-sm mb-1">
                                <span>
                                    <i class="la la-search"></i>
                                    <span>{{ $t('common.ApplyFilters')}}</span>
                                </span>
                            </button>
                            <a class="btn btn-metal btn-sm  m-btn m-btn--custom m-btn--icon btn more-options collapsed btn-block-sm mb-1"
                               role="button" data-toggle="collapse"
                               href="#more-filters"
                               id="filtersBtn"
                               aria-expanded="false" aria-controls="more-filters">
                              <i class="flaticon-interface-6 m--icon-font-size-sm2 d-inline pr-2"></i>
                              <span
                                id="moreFiltersSpan"
                                class="d-inline moreFiltersSpan">{{ $t('Property.Analytics.Morefilters')}}</span>
                            </a>
                          </div>

                        </div>
                        <div class="row collapse pt-4" id="more-filters">
                          <div class=" m-separator mb-3 m-separator--md"></div>

                          <div class="col-lg-12" id="viewFilter">
                            <div class="row">

                              <div class="col-12 col-sm-6">

                                <div class=" row ">
                                  <label class="col-xl-12 col-form-label" for="Id">
                                    {{$t('Directory.Analytics.DirectoryId')}}: <span class="m-form__help"> ({{$t('common.multipleSelection')}})</span>
                                  </label>
                                  <div class="col-xl-12">
                                    <v-select
                                      id="Id"
                                      ref="idSelects"
                                      v-model="filter.id"
                                      :multiple="true"
                                      :searchable="true"
                                      placeholder="12345,5678,9345"
                                      :taggable="true"
                                      class="custom-select form-control m-input--solid"
                                      :select-on-key-codes="[188, 13]">
                                      <template slot="no-options">
                                           &nbsp;
                                      </template>
                                    </v-select>
                                  </div>
                                </div>
                              </div>

                              <div class="col-12 col-sm-6">
                                <div class=" row ">
                                  <label class="col-xl-12 col-form-label" for="language">
                                    {{$t('Property.Analytics.language')}}:
                                  </label>
                                  <div class="col-xl-12">
                                    <select id="language" name="Language"
                                            v-model="filter.language"
                                            class="custom-select form-control m-input--solid">
                                      <option v-for="language in languages" :value="language.code" v-bind:key="language.code">{{language.name}}</option>
                                    </select>
                                  </div>
                                </div>
                              </div>

                              <div class="col-12 col-sm-6">

                                <div class=" row ">
                                  <label class="col-xl-12 col-form-label" for="device">
                                    {{$t('Property.Analytics.VisitorsDevice')}}:
                                  </label>
                                  <div class="col-xl-12">
                                    <select id="device" name="Device"
                                            v-model="filter.device"
                                            class="custom-select form-control m-input--solid">
                                      <option value="">{{$t('Property.Analytics.Any')}}</option>
                                      <option value="mobile">{{$t('devices.mobile')}}</option>
                                      <option value="tablet">{{$t('devices.tablet')}}</option>
                                      <option value="desktop">{{$t('devices.desktop')}}</option>
                                      <option value="smarttv">{{$t('devices.smart')}}</option>
                                      <option value="n/a">{{$t('devices.bot')}}</option>
                                    </select>
                                  </div>
                                </div>
                              </div>

                              <div class="col-12 col-sm-6">
                                <div class=" row ">
                                  <label class="col-xl-12 col-form-label" for="country">
                                    {{$t('Property.Analytics.VisitorsCountry')}}:
                                  </label>
                                  <div class="col-xl-12">
                                    <select id="country" name="Country"
                                            v-model="filter.country"
                                            class="custom-select form-control m-input--solid">
                                      <option v-for="country in countries" :value="country.code" v-bind:key="country.code">{{country.name}}</option>
                                    </select>
                                  </div>
                                </div>
                              </div>

                            </div>
                          </div>
                          <div class="col-lg-12">
                            <div class="form-group">
                              <div class="mt-3">
                                <button type="submit" class="btn btn-brand btn-sm m-btn m-btn--custom m-btn--icon btn-block-sm">
                                    <span>
                                        <i class="la la-search"></i>
                                        <span>{{ $t('common.ApplyFilters')}}</span>
                                    </span>
                                </button>
                                <a class="btn btn-metal btn-sm  m-btn m-btn--custom m-btn--icon btn more-options collapsed"
                                   role="button" data-toggle="collapse"
                                   href="#more-filters" aria-expanded="false" aria-controls="more-filters">
                                  <i class="flaticon-interface-6 m--icon-font-size-sm2 d-inline pr-2"></i>
                                  <span class="d-inline">{{ $t('Property.Analytics.Hidefilters')}}</span>
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-lg-12">
                            <div class=" m-separator my-3 m-separator--md"></div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-xl-8 col-lg-8 col-md-9 col-sm-9" id="metricSelection">
                            <div class="form-inline">
                              <label for="metric1" class="control-label mr-2">{{$t('Property.Analytics.ViewMetric')}}:</label>
                              <select id="metric1" class="custom-select form-control m-input--solid" name="Metric"
                                      v-model="filter.Metric"
                                      @change="changedMetrics">

                                <option value="view" v-if="filter.metric2 !== 'view'">{{$t('homepage.stats.TotalViews')}}</option>
                                <option value="detailed" v-if="filter.metric2 !== 'detailed'">{{$t('homepage.stats.DetailedViews')}}</option>
                                <option value="enquiry" v-if="filter.metric2 !== 'enquiry'">{{$t('homepage.stats.Enquiries')}}</option>
                                <option value="go-to-website" v-if="filter.metric2 !== 'go-to-website'">{{$t('homepage.stats.WebsiteVisits')}}</option>
                              </select>
                              <label for="metric2" class="control-label mx-2">vs</label>
                              <select id="metric2" class="custom-select form-control m-input--solid" name="Metric2"
                                      v-model="filter.metric2"
                                      @change="changedMetrics">
                                <option value="view" v-if="filter.Metric !== 'view'">{{$t('homepage.stats.TotalViews')}}</option>
                                <option value="detailed" v-if="filter.Metric !== 'detailed'">{{$t('homepage.stats.DetailedViews')}}</option>
                                <option value="enquiry" v-if="filter.Metric !== 'enquiry'">{{$t('homepage.stats.Enquiries')}}</option>
                                <option value="go-to-website" v-if="filter.Metric !== 'go-to-website'">{{$t('homepage.stats.WebsiteVisits')}}</option>
                              </select>
                            </div>
                          </div>
                          <div class="col-xl-4 col-lg-4 col-md-3 col-sm-3" style="text-align: right;"
                               id="intervalSelection">
                            <div class="form-inline pull-right">
                              <label for="interval" class="control-label"></label>
                              <select class="custom-select form-control m-input--solid" id="interval"
                                      v-model="filter.interval"
                                      @change="changedInterval"
                                      name="Interval">
                                <option value="day">{{$t('Property.Analytics.Day')}}</option>
                                <option value="week">{{$t('Property.Analytics.Week')}}</option>
                                <option value="month">{{$t('Property.Analytics.Month')}}</option>
                              </select>
                            </div>
                          </div>
                        </div>
                        <hr/>
                        <div class="row">
                          <div class="col-lg-12">
                            <div class="panel panel-default">
                              <div class="panel-heading">
                                <h3 class="panel-title">{{$t('Property.Analytics.Metrics')}}</h3>
                              </div>
                              <div class="panel-body">
                                <div :id="'DirectoryChart'" :ref="'chart'" style="width:100%;height:400px"></div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </form>
                    </div>
                    <div class="row">
                      <div class="col-lg-12">
                        <div class="panel panel-default" id="dimentions">
                          <div class="panel-heading">
                            <h3 class="panel-title my-5">{{$t('Property.Analytics.Dimensions')}}</h3>
                          </div>
                          <div class="panel-body">
                            <div class="form-inline">
                              <label for="dimention1" class="control-label mr-2">{{$t('Property.Analytics.SelectDimension')}}:</label>
                              <select id="dimention1" class="custom-select form-control m-input--solid"
                                      v-model="filter.dimention"
                                      @change="changedDimensions">

                                <option value="province">{{$t('Property.Analytics.province')}}</option>
                                <option value="region">{{$t('Property.Analytics.region')}}</option>
                                <option value="town">{{$t('Property.Analytics.town')}}</option>

                                <option value="language" selected>{{$t('Property.Analytics.language')}}</option>
                                <option value="device">{{$t('Property.Analytics.VisitorsDevice')}}</option>
                                <option value="country">{{$t('Property.Analytics.VisitorsCountry')}}</option>

                              </select>
                            </div>
                            <br/>
                            <div class="table-responsive">
                              <table id="tableDim"
                                     class="table table-striped table-bordered with-header-border not-responsive not-collapse"
                                     style="border: 2px solid #e6e7eb !important">
                                <thead>
                                <tr>
                                  <th rowspan="3"></th>
                                  <th colspan="2" class="noofpropertiesdoble"></th>
                                  <th colspan="6" class="noofpropertiesdoble">thinkSPAIN</th>
                                </tr>
                                <tr>
                                  <th colspan="2">{{$t('Property.table.totals')}}</th>
                                  <th colspan="2" class="noofpropertiesdoble">{{$t('Property.table.standard')}}</th>
                                  <th colspan="2" class="noofpropertiesdoble">{{$t('Property.table.featured')}}</th>
                                  <th colspan="2" class="noofpropertiesdoble">{{$t('Property.table.premium')}}</th>
                                </tr>
                                <tr>
                                  <!-- DIMENSIONS HERE -->
                                  <th>{{$t('homepage.stats.'+this.searchFilter.Metric)}}</th>
                                  <th>{{$t('homepage.stats.'+this.searchFilter.metric2)}}</th>

                                  <th class="noofpropertiesdoble">{{$t('homepage.stats.'+this.searchFilter.Metric)}}</th>
                                  <th class="noofpropertiesdoble">{{$t('homepage.stats.'+this.searchFilter.metric2)}}</th>

                                  <th class="noofpropertiesdoble">{{$t('homepage.stats.'+this.searchFilter.Metric)}}</th>
                                  <th class="noofpropertiesdoble">{{$t('homepage.stats.'+this.searchFilter.metric2)}}</th>

                                  <th class="noofpropertiesdoble">{{$t('homepage.stats.'+this.searchFilter.Metric)}}</th>
                                  <th class="noofpropertiesdoble">{{$t('homepage.stats.'+this.searchFilter.metric2)}}</th>
                                  <!-- END DIMENSIONS HERE -->
                                </tr>
                                </thead>
                                <tbody>
                                  <tr v-for="dimention in dimentions">
                                    <td> {{ dimention.description }} </td>
                                    <td> {{ dimention.m1.standard + dimention.m1.featured + dimention.m1.premium }}</td>
                                    <td> {{ dimention.m2.standard + dimention.m2.featured + dimention.m2.premium }}</td>
                                    <td> {{ dimention.m1.standard }}</td>
                                    <td> {{ dimention.m2.standard }}</td>
                                    <td> {{ dimention.m1.featured }}</td>
                                    <td> {{ dimention.m2.featured }}</td>
                                    <td> {{ dimention.m1.premium }}</td>
                                    <td> {{ dimention.m2.premium }}</td>
                                  </tr>
                                </tbody>
                              </table>

                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
      <template v-if="canSeeContractDirectoryService">
        <NoDirectoryServices/>
      </template>

    </div>
    <!-- end:: Body -->

    <!-- BEGIN: Footer -->
    <AppFooter/>
    <!-- END: Footer -->
  </div>
</template>

<script>

  import AppHeader from '@/components/dashboard/common/Header'
  import AppFooter from '@/components/dashboard/common/Footer'
  import LeftMenu from '@/components/dashboard/common/menus/LeftMenu'
  import NoDirectoryServices from '@/components/dashboard/services/Directory'

  import vSelect from 'vue-select'
  import functions from "@/plugins/functions";
  import data from "@/plugins/data";
  import locationAPI from '@/interceptors/locationapi'
  import {clientanalyticsapi} from '@/interceptors/clientanalyticsapi'
  import dayjs from 'dayjs'

  export default {
    components: {
      AppFooter,
      AppHeader,
      LeftMenu,
      NoDirectoryServices,
      vSelect
    },
    data() {
      return {
        filter: {
          FromDate: dayjs().tz().subtract(30, 'days').format('YYYY-MM-DD'),
          ToDate: dayjs().tz().subtract(1, 'days').format('YYYY-MM-DD'),
          dimention: 'language',
          interval: 'day',
          Metric: 'view',
          metric2: 'enquiry',
          id: [],
          device: "",
          language: '',
          country: ''
        },
        user: {},
        directoryService: null,
        searchFilter: {},
        countries: [],
        languages: [],
        dimensionTable: '',
        labelsAux: [],
        labelsAuxComputed: [],
        dateText: this.$t('homepage.stats.Date'),
        Metric: this.$t('Property.Analytics.TotalViews'),
        metric2: this.$t('Property.Analytics.Enquiries'),
        dimentions: [],
        range: 30,
        chartData: {},
        chartOptions: {}
      };
    },
    async created() {
      window.addEventListener("resize", this.reDrawChart);

      let byName = function(c1, c2) {
        var name1 = c1.name.toUpperCase();
        var name2 = c2.name.toUpperCase();
        if (name1 < name2) {
          return -1;
        }
        if (name1 > name2) {
          return 1;
        }
        return 0;
      };

      this.user = functions.getUser()
      this.directoryService = await functions.getDirectoryService()

      if (this.directoryService.Status != 'ACTIVE'){
        return
      }

      let lang = this.userLang

      let listOfCounries = data.countries().map((country) => { return { code: country.Code, name: country.Labels[lang] } }).sort(byName)
      listOfCounries.unshift({ code: '', name: this.$t('common.select') })
      this.countries = listOfCounries

      let listOfLanguages  = data.languages().map(language => { return { code: language.code, name: language.Labels[lang]}}).sort(byName)
      listOfLanguages.unshift({code: '', name: this.$t('common.select') })
      this.languages = listOfLanguages

      this.updateParamsFromRoute();

      this.loadExternalScripts();
      this.setUpHideShowFilters();
    },
    destroyed() {
      window.removeEventListener("resize", this.reDrawChart);
    },
    computed: {
      userLang(){
        return this.$i18n.locale
      },
      canSeeAnalyticsDirectorySection() {
        return this.directoryService && this.directoryService.Status == 'ACTIVE'
      },
      canSeeContractDirectoryService(){
        return this.directoryService && this.directoryService.Status != 'ACTIVE'
      }
    },
    watch: {
      '$route.query': {
        handler: function( newquery, oldquery ) {
          if (this.directoryService.Status != 'ACTIVE'){
            return
          }

          // check which query param changed (newQuery vs oldQuery)
          let changedParams = [];

          let newQuery = this.getParamsFromRouteQuery( newquery );
          let oldQuery = this.getParamsFromRouteQuery( oldquery );

          // Check if each parameter in the new query has changed (or was empty or same as default)
          for (let param in newQuery) {
              if (JSON.stringify(newQuery[param]) !== JSON.stringify(oldQuery[param])) {
                  changedParams.push( param );
              }
          }

          // Check if each parameter in the new query has changed
          for (let param in oldQuery) {
              if (JSON.stringify(oldQuery[param]) !== JSON.stringify(newQuery[param]) ) {
                  if (!changedParams.includes(param)) {
                    changedParams.push( param );
                  }
              }
          }

          this.updateParamsFromRoute();
          this.searchFilter = JSON.parse(JSON.stringify(this.filter));

          // has only dimention changed?
          let dimentionOnly = changedParams.length == 1 && (changedParams.includes('dimention') );

          if ( dimentionOnly  ) {
            this.queryDimensions()
            return;
          }

          let intervalOnly = changedParams.length == 1 && changedParams.includes('interval');

          if ( intervalOnly ) {
            this.queryMetrics()
            return;
          }

          this.queryDimensions();
          this.queryMetrics();

        },
        immediate: false,
      },
    },
    methods: {
      getDefaultParams() {
        return {
          FromDate: dayjs().tz().subtract(30, 'days').format('YYYY-MM-DD'),
          ToDate: dayjs().tz().subtract(1, 'days').format('YYYY-MM-DD'),
          dimention: 'language',
          interval: 'day',
          Metric: 'view',
          metric2: 'enquiry',
          id: [],
          device: "",
          language: '',
          country: '',
          Skip: 0
        }
      },
      updateParamsFromRoute() {
        let params = this.getParamsFromRouteQuery( this.$route.query );
        this.filter = params;
      },
      getParamsFromRouteQuery( query ) {
        let params = {}

        let defaultParams = this.getDefaultParams();

        params.FromDate = query.fromdate || defaultParams.FromDate;
        params.ToDate = query.todate || defaultParams.ToDate;
        params.dimention = query.dimention || defaultParams.dimention;
        params.Metric = query.metric || defaultParams.Metric;
        params.metric2 = query.metric2 || defaultParams.metric2;
        params.interval = query.interval || defaultParams.interval;

        let ids = []

        // convert query.types to array of ints
        if (query.id) {
          if (Array.isArray(query.id)) {
            ids = query.id
          } else {
            ids = [query.id]
          }
        }

        params.id = ids || defaultParams.id;
        params.device = query.device || defaultParams.device;
        params.language = query.language || defaultParams.language;
        params.country = query.country || defaultParams.country;

        return params;
      },
      updateRouteFromParams() {
        let params = this.filter
        let defaultParams = this.getDefaultParams();

        let newRouteParams = {
          fromdate: params.FromDate,
          todate: params.ToDate,
        }

        if (params.dimention != defaultParams.dimention) {
          newRouteParams.dimention = params.dimention
        }

        if (params.Metric != defaultParams.Metric) {
          newRouteParams.metric = params.Metric
        }

        if (params.metric2 != defaultParams.metric2) {
          newRouteParams.metric2 = params.metric2
        }

        if (params.interval != defaultParams.interval) {
          newRouteParams.interval = params.interval
        }

        if (params.id != defaultParams.id) {
          newRouteParams.id = params.id
        }

        if (params.device != defaultParams.device) {
          newRouteParams.device = params.device
        }

        if (params.language != defaultParams.language) {
          newRouteParams.language = params.language
        }

        if (params.country != defaultParams.country) {
          newRouteParams.country = params.country
        }

        if (JSON.stringify(this.$route.query) !== JSON.stringify(newRouteParams)) {
          this.$router.push({ query: newRouteParams });
        }
      },
      reDrawChart() {
        let chartElement = document.getElementById("DirectoryChart");

        if (!chartElement) {
          return;
        }
        if (this.chartData && this.chartOptions) {
          let chart = new google.visualization.AreaChart(chartElement);
          chart.draw(this.chartData, this.chartOptions);
        }
      },
      setUpHideShowFilters(){
        let vueThis = this;

        let form = document.getElementById('filterForm')
        let $form = $(form);

        let moreFiltersSpans = document.querySelector('.moreFiltersSpan');

        $form.on('hide.bs.collapse', function () {
          moreFiltersSpans.innerHTML = vueThis.$t('Property.Analytics.MoreFilters')
        })
        $form.on('show.bs.collapse', function () {
          moreFiltersSpans.innerHTML = vueThis.$t('Property.Analytics.Hidefilters')
        })
      },
      changedMetrics(){
        this.updateRouteFromParams();
      },
      changedDimensions(){
        this.updateRouteFromParams();
      },
      changedInterval(){
        this.updateRouteFromParams();
      },
      startSearch() {
        this.updateRouteFromParams();
      },
      search(){
        this.searchFilter = JSON.parse(JSON.stringify(this.filter));

        this.queryMetrics()
        this.queryDimensions()
      },
      async queryMetrics() {

        let metricRequest = {
          Metric: this.searchFilter.Metric,
          Interval: this.searchFilter.interval,
          From: dayjs(this.searchFilter.FromDate).tz().format(),
          To: dayjs(this.searchFilter.ToDate).tz().add(1, "day").subtract(1, "millisecond").format(),
          Login: this.user.Login,
          Id: this.searchFilter.id,
          Device: this.searchFilter.device,
          Language: this.searchFilter.language,
          Country: this.searchFilter.country
        };

        this.chartLoading(true);

        let queryMetric1 = clientanalyticsapi.post('/directory/metrics', metricRequest)

        let metric2Request = JSON.parse(JSON.stringify(metricRequest));
        metric2Request.Metric = this.searchFilter.metric2;

        let queryMetric2 = clientanalyticsapi.post("/directory/metrics", metric2Request)

        let resultMetric1 = await queryMetric1
        let resultMetric2 = await queryMetric2

        this.chartLoading(false);

        if (resultMetric1.status != 200 || resultMetric2.status != 200){
          swal({
            title: this.$t('error.AnErrorOccurred'),
            type: "error",
            confirmButtonClass: "btn btn-brand m-btn m-btn--wide",
            onBeforeOpen: () => { functions.onBeforeOpenSwal() }
          })
          return;
        }

        this.drawChart(resultMetric1.data, resultMetric2.data)
      },
      async queryDimensions() {

        let dimentionRequest = {
          Dimention: this.searchFilter.dimention,
          Metric: this.searchFilter.Metric,
          Interval: this.searchFilter.interval,
          From: dayjs(this.searchFilter.FromDate).tz().format(),
          To: dayjs(this.searchFilter.ToDate).tz().add(1, "day").subtract(1, "millisecond").format(),
          Login: this.user.Login,
          Id: this.searchFilter.id,
          Device: this.searchFilter.device,
          Language: this.searchFilter.language,
          Country: this.searchFilter.country
        };

        this.dimensionLoading(true)

        let queryDimention1 = clientanalyticsapi.post('/directory/dimentions', dimentionRequest);

        let dimention2Request = JSON.parse(JSON.stringify(dimentionRequest));
        dimention2Request.Metric = this.searchFilter.metric2;

        let queryDimention2 = clientanalyticsapi.post('/directory/dimentions', dimention2Request)

        let resultDimetion1 = await queryDimention1
        let resultDimetion2 = await queryDimention2

        this.dimensionLoading(false);

        if (resultDimetion1.status != 200 || resultDimetion2.status != 200) {
          swal({
            title: this.$t('error.AnErrorOccurred'),
            type: "error",
            confirmButtonClass: "btn btn-brand m-btn m-btn--wide",
            onBeforeOpen: () => { functions.onBeforeOpenSwal() }
          })
          return
        }

        this.setTableData(resultDimetion1.data, resultDimetion2.data)
      },
      async setTableData(result1Dimention, result2Dimention){

        let dimentions = {}

        Object.keys(result1Dimention).forEach((eventName, index) => {
          Object.keys(result1Dimention[eventName].thinkspain).forEach((dimentionKey) => {
            if (!dimentions[dimentionKey]){
              dimentions[dimentionKey] = { name: dimentionKey, m1: { standard: 0, featured: 0, premium: 0 }, m2: { standard: 0, featured: 0, premium: 0 }}
            }

            if (eventName.endsWith('-featured-premium')) {
              dimentions[dimentionKey].m1.premium += result1Dimention[eventName].thinkspain[dimentionKey]
            } else if (eventName.endsWith('-featured')) {
              dimentions[dimentionKey].m1.featured += result1Dimention[eventName].thinkspain[dimentionKey]
            } else {
              dimentions[dimentionKey].m1.standard += result1Dimention[eventName].thinkspain[dimentionKey]
            }
          })
        })

        Object.keys(result2Dimention).forEach((eventName, index) => {
          Object.keys(result2Dimention[eventName].thinkspain).forEach((dimentionKey) => {
            if (!dimentions[dimentionKey]){
              dimentions[dimentionKey] = { name: dimentionKey, m1: { standard: 0, featured: 0, premium: 0 }, m2: { standard: 0, featured: 0, premium: 0 }}
            }

            if (eventName.endsWith('-featured-premium')) {
              dimentions[dimentionKey].m2.premium += result2Dimention[eventName].thinkspain[dimentionKey]
            } else if (eventName.endsWith('-featured')) {
              dimentions[dimentionKey].m2.featured += result2Dimention[eventName].thinkspain[dimentionKey]
            } else {
              dimentions[dimentionKey].m2.standard += result2Dimention[eventName].thinkspain[dimentionKey]
            }
          })
        })

        let dimention = this.searchFilter.dimention.toLowerCase()

        for (let key in dimentions) {
          switch(dimention){
            case 'region':
            case 'town':
            case 'province': {
                let location = await locationAPI.get(`/${dimention}/${key}`)
                dimentions[key].description = location.data.Labels.Default
              }
              break;
            case 'country': {
              let countries = this.countries;
              let userLang = this.userLang
              countries.forEach(function (country, index) {
                if (country.code === key){
                  dimentions[key].description = countries[index].name
                }
              })
              break;
            }
            case 'language': {
              dimentions[key].description = this.$t('language.' + key)
              break;
            }
            case 'device': {
              dimentions[key].description = this.$t('devices.'+key)
              break;
            }
          }
        }

        this.dimentions = dimentions

      },
      loadExternalScripts(){
        let component = this
        let googleChartScripts = document.createElement('script')
        googleChartScripts.onload = () => {
          component.externalScriptsLoaded()
        }
        googleChartScripts.setAttribute('src', 'https://www.gstatic.com/charts/loader.js')
        document.head.appendChild(googleChartScripts)
      },
      externalScriptsLoaded(){
        let component = this
        google.charts.load('current', {packages: ['corechart', 'line']});
        google.charts.setOnLoadCallback(function(){ component.search() });
      },
      dimensionLoading(spin) {
        if (spin){
          mApp.block("#dimentions", {message: this.$t('common.LoadingDataPleaseWait')})
        }else
          mApp.unblock("#dimentions")
      },
      chartLoading(spin) {
        if (spin)
          mApp.block("#metrics", {message: this.$t('common.LoadingDataPleaseWait')})
        else
          mApp.unblock("#metrics")
      },

      drawChart(metric1result, metric2result) {

        let myChart = new google.visualization.DataTable();

        let title1 = this.$t('homepage.stats.'+this.searchFilter.Metric);
        let title2 = this.$t('homepage.stats.'+this.searchFilter.metric2);

        myChart.addColumn('string', this.dateText);
        myChart.addColumn('number', title1);
        myChart.addColumn('number', title2);

        let chartElement = document.getElementById('DirectoryChart');

        if (!chartElement){
          return
        }

        let metric1Max = 0
        let metric2Max = 0

        metric1result.forEach((el, index) => {

          if (el.Value > metric1Max) {
            metric1Max = el.Value
          }

          let metric2Value = metric2result[index].Value

          if (metric2Value > metric2Max) {
            metric2Max = metric2Value
          }

          myChart.addRow([
            dayjs(el.Time).tz().format('DD MMM YYYY'),
            el.Value,
            metric2Value
          ])
        })

        let options = {
          enableInteractivity: true,
          colors: ['#4382ce', '#f4516c'],
          legend: 'top',
          width: '100%',
          title: null,
          fontSize: '12',
          italic: false,
          series: {
            0: {
              targetAxisIndex: 0,
              textStyle: {
                color: '#000',
                fontSize: '12',
                italic: false
              },
              italic: false
            },
            1: {
              targetAxisIndex: 1,
              textStyle: {
                color: '#000',
                fontSize: '12',
                italic: false
              },
              italic: false
            },
          },
          tooltip:{
            trigger: 'hover'
          },
          vAxes: {
            0: {
              italic: false,
              title: title1,
              textStyle: {
                color: '#000',
                fontSize: '12',
                italic: false
              },
              viewWindow: {
                min: 0,
                max: metric1Max + 2
              }
            },
            1: {
              italic: false,
              title: title2,
              textStyle: {
                color: '#000',
                fontSize: '12',
                italic: false
              },
              viewWindow: {
                min: 0,
                max: metric2Max + 2
              }
            }
          },
          vAxis: {
            viewWindowMode:'explicit',
            format: '0',
            italic: false,
            textStyle: {
              color: '#000',
              fontSize: '12',
              italic: false
            },
            title: {
              color: '#000',
              fontSize: '12',
              italic: false
            }
          },
          hAxis: {
            italic: false,
            textStyle: {
              color: '#000',
              fontSize: '12',
              italic: false
            },
            title: {
              color: '#000',
              fontSize: '12',
              italic: false
            }
          }
        }

        this.chartData = myChart;
        this.chartOptions = options;

        let chart = new google.visualization.AreaChart(chartElement);
        chart.draw(myChart, options);
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/dashboard/directory/analytics/DirectoriesAnalytics.vue